import SubscriptionCardRepository from "../SubscriptionCardRepository"

export default class PricingCustomSubscription extends SubscriptionCardRepository {
    static schemaId = "pricing_card3"

    constructor() {
        super(PricingCustomSubscription.schemaId)
    }
}
